"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Task = exports.ExecutionResultStatus = void 0;
var ExecutionResultStatus;
(function (ExecutionResultStatus) {
    ExecutionResultStatus["SUCCESS"] = "SUCCESS";
    ExecutionResultStatus["ERROR"] = "ERROR";
})(ExecutionResultStatus = exports.ExecutionResultStatus || (exports.ExecutionResultStatus = {}));
class Task {
    constructor(steps, passport, addons) {
        this.steps = steps;
        this.passport = passport;
        this.addons = addons;
        this.statistics = {
            startTime: new Date(),
            steps: [],
            runtimeInfo: {},
        };
        this.currentStep = undefined;
    }
    /**
     * Run task
     *
     * @param inputValue
     */
    run(inputValue) {
        return __awaiter(this, void 0, void 0, function* () {
            let lastOutputValue = inputValue;
            let taskError;
            for (let stepIndex = 0; stepIndex < this.steps.length; stepIndex += 1) {
                this.currentStep = this.steps[stepIndex];
                const { resultValue, info } = yield this.currentStep.run(this, lastOutputValue);
                this.statistics.steps.push(info);
                if (!info.success) {
                    taskError = info.error;
                    break;
                }
                else {
                    lastOutputValue = resultValue;
                }
            }
            const isAllStepsSuccessfullyFinished = this.statistics.steps.length === this.steps.length &&
                this.statistics.steps.every((stepStatistics) => stepStatistics.success);
            this.statistics.endTime = new Date();
            return {
                status: isAllStepsSuccessfullyFinished
                    ? ExecutionResultStatus.SUCCESS
                    : ExecutionResultStatus.ERROR,
                error: taskError,
                result: isAllStepsSuccessfullyFinished ? lastOutputValue : undefined,
                statistics: this.statistics,
            };
        });
    }
    /**
     * Cancels task
     *
     * @param reason
     */
    cancel(reason) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield ((_a = this.currentStep) === null || _a === void 0 ? void 0 : _a.cancel(this, reason));
        });
    }
    addRuntimeInfo(propertyName, propertyValue) {
        this.statistics.runtimeInfo[propertyName] = propertyValue;
    }
    emitAddonEvent(eventName, ...payload) {
        var _a;
        const eventParts = eventName.split('.');
        const addonName = eventParts[0];
        const internalEventName = eventParts[1];
        const foundAddon = (_a = this.addons) === null || _a === void 0 ? void 0 : _a.find((addon) => addon.addonName === addonName);
        const eventHandler = (foundAddon === null || foundAddon === void 0 ? void 0 : foundAddon.events)[internalEventName];
        eventHandler(...payload);
    }
}
exports.Task = Task;
//# sourceMappingURL=task.js.map